import type { SVGProps } from 'react';

export function ShrimpIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4.094 2C2.384 2 1 3.438 1 5.214c0 1.402.864 2.592 2.067 3.033.442.162.823.508.934.966.781 3.24 3.602 5.644 6.968 5.644h1.406a1 1 0 0 0 1-1V7.286a1 1 0 0 0-1-1H4.094c-.572 0-1.032-.478-1.032-1.072 0-.593.46-1.071 1.032-1.071h16.5c.571 0 1.031-.478 1.031-1.072 0-.593-.46-1.071-1.031-1.071zm6.531 18.929c0 .593.46 1.071 1.031 1.071h2.094a1 1 0 0 0 1-1v-1.522a1 1 0 0 0-.659-.94l-2.095-.761c-.537-.197-1.126.098-1.315.656s.094 1.17.632 1.366c.05.019.044.104-.007.122a1.07 1.07 0 0 0-.681 1.008m5.5-.059c0 .59.51 1.057 1.082.914a7.3 7.3 0 0 0 1.712-.664c.656-.354.523-1.257-.165-1.542l-2.04-.849a.42.42 0 0 0-.342.019.42.42 0 0 0-.247.366zm4.48-2.064c.414.173.9.05 1.14-.33a8.15 8.15 0 0 0 1.252-4.391c-.004-.728-.827-1.062-1.418-.636l-3.76 2.708c-.225.162-.321.448-.32.724 0 .35.162.702.485.836zM15.748 6.334c-.55-.054-.999.4-.999.952v6.571c0 .552.45.96.999 1.03q.138.016.274.05c.421.101.895.128 1.246-.125l4.51-3.242c.374-.27.521-.763.308-1.171-1.282-2.462-3.643-3.803-6.338-4.065m-7.53 2.809c0-.594.46-1.072 1.031-1.072s1.031.478 1.031 1.072-.46 1.071-1.031 1.071-1.031-.477-1.031-1.071" />
    </svg>
  );
}
